<template>
  <div class="feedback-screen">
    <div>
      <div v-if="type" class="feedback-img-container -mt_2 -mb_3">
        <unit-loader v-if="type === 'loading'"></unit-loader>
        <img
          v-else
          class="feedback-screen__image"
          :src="getfeedbackImg"
          :alt="type"
        />
      </div>
      <h1 v-html="title"></h1>
      <p v-if="text || $slots.text" class="feedback-text">
        <slot name="text">
          <span v-html="text"></span>
        </slot>
      </p>
      <ul v-if="itemList.length" class="-my_4 items-list">
        <li v-for="(item, key) in itemList" :key="key">
          {{ $t(item) }}
        </li>
      </ul>
      <h6 v-if="disclaimer" class="disclaimer -mt_6 -t_medium">
        {{ $t(disclaimer) }}
      </h6>
      <div class="text-center -mt_8 w-full">
        <slot>
          <sword-button-wuk
            v-for="(action, key) in actions"
            :key="key"
            :text="$t(action.label)"
            :type="action.type || 'button'"
            :theme="action.theme || 'primary'"
            size="large"
            class="btn-action"
            @click.native="$emit('action', action.name)"
          >
          </sword-button-wuk>
        </slot>
      </div>
      <router-link
        v-if="extraLink && extraLink.to"
        class="extra-link -t_black -my_6"
        :to="extraLink.to"
      >
        {{ $t(extraLink.label) }}
      </router-link>
    </div>
  </div>
</template>

<script>
import SwordButtonWuk from '@ui-kit/components/buttons/SwordButton.vue';
import { mapGetters } from 'vuex';
import { applicationStoreTypes } from '@/store/types';
import UnitLoader from '../common/UnitLoader.vue';

export default {
  name: 'FeedbackScreen',
  components: { SwordButtonWuk, UnitLoader },
  props: {
    type: {
      type: String,
      default: 'co_generic-error',
    },
    title: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    disclaimer: {
      type: String,
      default: '',
    },
    itemList: {
      type: Array,
      default: () => [],
    },
    actions: {
      type: Array,
      default: () => [],
    },
    extraLink: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      unitName: applicationStoreTypes.getters.UNIT_NAME,
    }),
    getfeedbackImg() {
      // eslint-disable-next-line import/no-dynamic-require, global-require
      return require(`@/assets/images/feedbacks/${this.type}.svg`);
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
$feedback-image-side: 80px;

.feedback-screen {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 100%;

  .feedback-img-container {
    display: flex;
    justify-content: center;
  }

  h1 {
    @extend %-t_bold;
    text-align: center;
    font-size: $font-base-22;
    margin: map-get($sh-spacers-wuk, 3) auto 0;
    line-height: 1.2;
  }

  .feedback-screen__image {
    width: $feedback-image-side;
    height: $feedback-image-side;
    margin-top: map-get($sh-spacers-wuk, 3);

    @media screen and (min-width: $tablet-size) {
      margin-top: 80px;
    }
  }

  p,
  h6,
  ul {
    max-width: 792px;
    margin: 0.5em auto;
  }

  .feedback-text {
    @extend %-mt_3;
    font-weight: 500;
    font-size: 0.875rem;

    &::v-deep {
      span span{
        @extend %-t_bold;
      }

      a {
        color: $color-primary-500;

        &:hover {
          color: $color-primary-600;
        }

        &:focus {
          box-shadow: 0 0 0 2px $color-grey-300;
        }
      }
    }
  }

  ul {
    padding-inline-start: 2.1875em;
    @media screen and (max-width: 550px) {
      padding-inline-start: 0.9375em;
    }

    li {
      list-style: disc;
    }
  }

  .extra-link {
    position: relative;
    display: block;
  }
}
</style>
